<template>
  <div class="h-full flex flex-col">
    <div>
      <el-page-header @back="$emit('cancel')" content="详情"></el-page-header>
    </div>
    <div class="flex-1 overflow-y-auto mt-20px">
      <div class="flex mb-20px mr-10px">
        <el-date-picker
          class="mr-10px"
          v-model="equipSearchData.datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button
          size="small"
          @click="handleEvent(null, 'batchExport')"
          :disabled="!$hasAccess('batchExport')"
          >导出</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
        @selection-change="handleSelectionEquip"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="被考核部门"
          prop="departmentName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="积分下发时间" prop="integralDeliveryTime" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.integralDeliveryTime
                ? dayjs(scope.row.integralDeliveryTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="被考核人"
          prop="assessorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="事件" prop="incident" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.incident == 0">按期排查任务</span>
            <span v-if="scope.row.incident == 1">上报重大隐患</span>
            <span v-if="scope.row.incident == 2">上报一般隐患</span>
            <span v-if="scope.row.incident == 3">完成隐患整改</span>
            <span v-if="scope.row.incident == 4">隐患排查超期</span>
            <span v-if="scope.row.incident == 5">隐患超期未整改</span>
            <span v-if="_.isNil(scope.row.incident)"></span>
          </template>
        </el-table-column>
        <el-table-column
          label="奖惩积分"
          prop="rewardAndPunishmentIntegral"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { DepartmentEvaluationApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'

const departmentEvaluationApi = new DepartmentEvaluationApi()

export default {
  name: 'depart-check-detail',
  props: {
    currentId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        datePickerValue: [],
        startTime: undefined,
        endTime: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
    }
  },
  created() {
    this.handleSearch()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'batchExport':
          ;[err, res] = await departmentEvaluationApi.exportDepartmentEvaluationDetails({
            fid: this.currentId,
            body:
              this.selectionEquipData && this.selectionEquipData.length > 0
                ? this.selectionEquipData
                : undefined,
          })
          if (!err) {
            this.downLoadExcel('部门考核详情记录', res)
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        default:
          break
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      this.equipSearchData.startTime =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[0]).format('YYYY-MM-DD')
          : undefined
      this.equipSearchData.endTime =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[1]).format('YYYY-MM-DD')
          : undefined
      const equipSearchData = utils.deleteFormField(this.equipSearchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        id: this.currentId,
        ...equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await departmentEvaluationApi.getDepartmentEvaluationDetails(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
